import PropTypes from 'prop-types';
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";

import { MainLayout } from "@gyandiksha/shared-ui/layouts";
import { ProtectedRoute } from "@gyandiksha/shared-ui/routes";
import { MODULE_IDS, useSidebarMenuConfig } from '@gyandiksha/shared-ui/hooks/useSidebarMenuConfig.js';
import { getFirstNavigationPath } from "@gyandiksha/shared-ui/utils";
import { PageNotFound, PageLoader } from "@repo/design-system/components/ui";
import { sidebarMenuConfig as defaultSidebarMenuConfig } from "@/navigation/sidebarmenu.config";

const AppRoutes = (props) => {

    const { sidebarMenuConfig, isFetching } = useSidebarMenuConfig({ moduleId: MODULE_IDS.usk_scholarship });
    const defaultPath = getFirstNavigationPath(sidebarMenuConfig)
        || getFirstNavigationPath(defaultSidebarMenuConfig);

    return (
        <Router>
            {/* <Suspense fallback={<PageLoader />}> */}
            <Routes>
                <Route path="/" element={
                    isFetching ? <PageLoader /> : <Navigate to={defaultPath} replace />
                } />
                <Route name="Layout" path="/"
                    element={
                        <ProtectedRoute sidebarMenuConfig={sidebarMenuConfig}>
                            {isFetching ? (
                                <PageLoader />
                            ) : (
                                <MainLayout componentRoutes={props.componentRoutes}
                                    sidebarMenuConfig={sidebarMenuConfig || defaultSidebarMenuConfig} />
                            )}
                        </ProtectedRoute>
                    }>
                    {props.componentRoutes.map((route) => (
                        <Route key={route.path} path={route.path}
                            name=""
                            element={< route.component />} />
                    ))}

                    {props.componentRoutes.map((route) => (
                        route?.children?.map((childRoute) => (
                            <Route
                                key={childRoute.path}
                                path={childRoute.path}
                                element={<childRoute.component securityKey={childRoute?.securityKey} />}
                            />
                        ))
                    ))}

                    <Route index element={<Navigate to={defaultPath} replace />} />
                </Route>
                <Route path="*" element={<PageNotFound />} />
            </Routes>
            {/* </Suspense> */}
        </Router>
    );
};

AppRoutes.propTypes = {
    componentRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            component: PropTypes.elementType.isRequired,
            securityKey: PropTypes.string.isRequired,
            children: PropTypes.arrayOf(
                PropTypes.shape({
                    path: PropTypes.string.isRequired,
                    component: PropTypes.elementType.isRequired,
                    securityKey: PropTypes.string.isRequired,
                })
            ),
        })
    ).isRequired,
};

export default AppRoutes;
